import { DiscriminatorTypeDto, OfferElementTypeDto, UnitMeasurementDto } from '@/api/generated';
import { unitMeasurementOptionsTranslation } from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import { OfferElementDetailsPricesConditionalAddFormModel } from '@/views/offerElements/details/components/pricesList/components/conditionalPrices/components/add/model/OfferElementDetailsPricesConditionalAddForm.model.ts';
import { OfferElementDetailsPricesListConditionalAddContainerDialogFormModel } from '@/views/offerElements/details/components/pricesList/components/conditionalPrices/components/addContainerDialog/model/OfferElementDetailsPricesListConditionalAddContainerDialogForm.model.ts';

export type DiscriminatorTypeOptions = Record<DiscriminatorTypeDto, string>;
export type OfferElementTypeOptions = Record<OfferElementTypeDto, string>;
export type OfferElementUnitMeasurementOptions = Record<UnitMeasurementDto, string>;

export const offerElementTypeOptions: OfferElementTypeOptions = {
  [OfferElementTypeDto.Decoration]: 'Dekoracje',
  [OfferElementTypeDto.DishPackages]: 'Dania',
  [OfferElementTypeDto.DrinkPackages]: 'Zestawy napojów',
  [OfferElementTypeDto.Equipment]: 'Sprzęt',
  [OfferElementTypeDto.Service]: 'Obsługa',
  [OfferElementTypeDto.Transport]: 'Transport',
};

export const offerElementDiscriminatorTypeOptions: DiscriminatorTypeOptions = {
  [DiscriminatorTypeDto.PackageDishWithBasicPrice]: 'Zestaw dań',
  [DiscriminatorTypeDto.PackageWithBasicPrice]: 'Zestaw',
  [DiscriminatorTypeDto.PackageWithConditionalPrices]: 'Zestaw z cenami warunkowymi',
  [DiscriminatorTypeDto.WithBasicPrice]: 'Element',
  [DiscriminatorTypeDto.WithConditionalPrices]: 'Element z cenami warunkowymi',
};

export const offerElementDiscriminatorTypeDescriptions: DiscriminatorTypeOptions = {
  [DiscriminatorTypeDto.PackageDishWithBasicPrice]:
    'Strukturyzowane menu z grupami dań (dział kuchni, kategoria, gramatura, lista dań do wyboru). Stała cena za sztukę. Przykłady: menu weselne 3-daniowe, lunch konferencyjny, bufet komunijny.',
  [DiscriminatorTypeDto.PackageWithBasicPrice]:
    'Pakiet ze stałą ceną i listą "co wchodzi w skład" (składowe wybierane ze słownika). Przykłady: przerwa kawowa, Open Bar standard, dekoracja stołu, transport.',
  [DiscriminatorTypeDto.PackageWithConditionalPrices]:
    'Pakiet z cenami progowymi (per osoba/godzina) i listą składowych. Jednostka tylko: osoby lub godziny. Przykłady: Open Bar Premium z progami, pakiet konferencyjny.',
  [DiscriminatorTypeDto.WithBasicPrice]:
    'Pojedyncza pozycja ze stałą ceną (cena × ilość). Bez listy składowych. Przykłady: koordynator wesela, tort, sprzątanie, drobna usługa.',
  [DiscriminatorTypeDto.WithConditionalPrices]:
    'Pojedyncza pozycja z cenami progowymi (od X osób / godzin → cena Y). Jednostka tylko: osoby lub godziny. Przykłady: woda bez limitu per osoba, DJ na godzinę, hostessa.',
};

export type FormConditionalContainerType = Record<
  keyof OfferElementDetailsPricesListConditionalAddContainerDialogFormModel,
  string
>;
export const formConditionalContainer: FormConditionalContainerType = {
  oversizeOrderUnitPrice: 'Cena za dodatkow(ą/y)',
  validFrom: 'Ważna od',
  validTo: 'Ważna do',
};

export type OfferElementMainDetails = {
  active: string;
  name: string;
  type: string;
  typeOptions: OfferElementTypeOptions;
  unit: string;
  unitOptions: OfferElementUnitMeasurementOptions;
};

export const offerElementMainDetails: OfferElementMainDetails = {
  active: 'Aktywny',
  name: 'Nazwa',
  type: 'Typ',
  typeOptions: offerElementTypeOptions,
  unit: 'Jednostka',
  unitOptions: unitMeasurementOptionsTranslation,
};

export type OfferElementFormConditionalType = Record<
  keyof OfferElementDetailsPricesConditionalAddFormModel,
  string
>;
export const offerElementFormConditional: OfferElementFormConditionalType = {
  comment: 'Wskazówki do obliczeń',
  manuallyCalculatedPrice: 'Cena wyliczana przez sprzedawcę',
  minimumPrice: 'Cena minimalna',
  upToQuantity: 'Do liczby jednostek',
};
